module.exports = __webpack_public_path__ + "static/media/farmorchid.2bc13777.jpg";